import React from "react";
import { AlertTriangle, RefreshCw, Home } from "lucide-react";
import { reportClientError } from "../utils/clientErrorReporter";
import "./ErrorBoundary.css";

// Confine d'errore per le pagine: un errore di render in una pagina non smonta
// più tutta l'app (schermata bianca), mostra un messaggio con "Ricarica" e
// segnala l'errore al backend. `resetKey` (es. il pathname) fa ripartire il
// contenuto al cambio pagina.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error("ErrorBoundary:", error, info?.componentStack);
        reportClientError({
            source: "error-boundary",
            message: error?.message || String(error),
            stack: error?.stack,
            componentStack: info?.componentStack,
        });
    }

    componentDidUpdate(prevProps) {
        if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ error: null });
        }
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div className="eb-container" role="alert">
                <div className="eb-card">
                    <AlertTriangle size={36} className="eb-icon" />
                    <h2>Si è verificato un errore in questa pagina</h2>
                    <p>
                        L'errore è stato segnalato automaticamente. Ricarica la pagina per riprovare;
                        se il problema persiste, torna alla home e riapri la sezione.
                    </p>
                    {process.env.NODE_ENV !== "production" && (
                        <pre className="eb-detail">{String(this.state.error?.stack || this.state.error)}</pre>
                    )}
                    <div className="eb-actions">
                        <button className="eb-btn eb-btn-primary" onClick={() => window.location.reload()}>
                            <RefreshCw size={15} /> Ricarica la pagina
                        </button>
                        <button className="eb-btn" onClick={() => { window.location.href = "/"; }}>
                            <Home size={15} /> Torna alla home
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
